<div class="top-card-container">
  <div class="top-card">
    <div class="icon-container">
      <img height="24" width="24" [ngSrc]="'assets/img/app-icon/' + icon + '.svg'" alt="">
    </div>

    <h1 class="title">{{title | translate}}</h1>

    <div class="action-container">
      <button type="button" class="btn" aria-label="Start for free" (click)="goToSignUpPage()">
        <img class="desktop" height="24" width="24" ngSrc="assets/img/cursor.svg" alt="">
        <img class="tablet" height="24" width="24" ngSrc="assets/img/finger-tap.svg" alt="">
        {{'MAIN.START_FOR_FREE' | translate}}
      </button>
    </div>

  </div>
</div>
